<div id="updateAntennaDiv" class="modal modal-lg modal-dialog fade in" role="dialog" style="display: none;" appDraggable dragTarget="#updateAntennaDiv" dragHandle="#entityTypeDialogHeader">
	<div class="modal-content">

		<!-- Dialog Header -->
		<div class="modal-header" id="entityTypeDialogHeader">
			<button type="button" class="close"  data-dismiss="modal" (click)="hideDialog()"><i class="fa fa-times" aria-hidden="true"></i></button>

			<div *ngIf="isNewDialog()">
				<h4 class="modal-title"><i class="fa fa-plus"></i> CREATE NEW {{entityTypeName}} Type</h4>
			</div>

			<div *ngIf="isEditDialog()">
				<h4 class="modal-title"><i class="fa fa-refresh"></i> UPDATE {{entityTypeName}}</h4>
			</div>
		</div>

		<!-- Dialog Body -->
		<div class="modal-body">

			<!-- Navigation Header -->
			<ul class="nav nav-tabs">
				<li class="active"><a data-toggle="tab" href="#information">INFORMATION</a></li>
				<li><a data-toggle="tab" href="#additionalParams">ADDITIONAL PARAMETERS</a></li>
			</ul>

			<!-- Tabs -->
			<div class="tab-content" style="height: 400px; overflow-y: auto; overflow-x: hidden" *ngIf="entity != null">

				<!-- Main Tab -->
				<div class="tab-pane fade in active" id="information">
					<div class="pageContent">

						<!-- ID -->
						<div class="row" *ngIf="isEditDialog()">
							<div class="form-group">
								<div class="col-sm-4"><label class="labelRequired">Id</label></div>
								<div class="col-sm-8"><input class="form-control" type="text" [(ngModel)]="entity.id" disabled /></div>
							</div>
						</div>

						<!-- Name -->
						<div class="row">
							<div class="form-group">
								<div class="col-sm-4"><label class="labelRequired">Name</label></div>
								<div class="col-sm-8"><input class="form-control" type="text" [(ngModel)]="entity.name" /></div>
							</div>
						</div>

						<!-- Tag Definition - Category -->
						<div class="row" *ngIf="isEntityType_Tag()">
							<div class="form-group">
								<div class="col-sm-4"><label class="labelRequired">Category</label></div>
								<div class="col-sm-8"><input class="form-control" type="text" [(ngModel)]="entity.category" /></div>
							</div>
						</div>

						<!-- Reader - Type -->
						<div class="row" *ngIf="isEntityType_Reader()">
							<div class="form-group">
								<div class="col-sm-4"><label class="labelRequired">Type</label></div>
								<div class="col-sm-8"><input class="form-control" type="text" [(ngModel)]="entity.type" /></div>
							</div>
						</div>

						<!-- Parent -->
						<div class="row">
							<div class="form-group">
								<div class="col-sm-4"><label class="labelNormal">Parent</label></div>
								<div class="col-sm-8">
									<select class="form-control" [(ngModel)]="entityParent" [ngModelOptions]="{standalone: true}" (change)="onSelectParent()">
										<option [ngValue]="null"> -- Choose -- </option>
										<ng-container *ngFor="let parent of mParents" >
	                    					<ng-container *ngIf="entity.id != parent.id">
												<option [ngValue]="parent" [selected]="entity.parent && entity.parent.id == parent.id" >
													{{parent.name}}
												</option>
											</ng-container>
										</ng-container>
									</select>
								</div>
							</div>
						</div>

						<!-- Description -->
						<div class="row">
							<div class="form-group">
								<div class="col-sm-4"><label class="labelNormal">Description</label></div>
								<div class="col-sm-8"><textarea rows="4" cols="40" class="form-control" [(ngModel)]="entity.description" ></textarea></div>
							</div>
						</div>

						<!-- Reader - Model -->
						<div class="row" *ngIf="isEntityType_Reader()">
							<div class="form-group">
								<div class="col-sm-4"><label class="labelNormal">Model</label></div>
								<div class="col-sm-8"><input class="form-control" type="text" [(ngModel)]="entity.model" /></div>
							</div>
						</div>

						<!-- Reader - Version -->
						<div class="row" *ngIf="isEntityType_Reader()">
							<div class="form-group">
								<div class="col-sm-4"><label class="labelNormal">Version</label></div>
								<div class="col-sm-8"><input class="form-control" type="text" [(ngModel)]="entity.version" /></div>
							</div>
						</div>

						<!-- Image -->
						<div class="row" *ngIf="!isEntityType_Location() && !isEntityType_Zone()">
							<div class="form-group">
								<div class="col-sm-4"><label class="labelNormal">Image</label></div>
								<div class="col-sm-8">
									<button class="btn btn-ef" type="button" style="width: 150px; margin-right: 20px; margin-bottom: 2px" (click)="changeImageClicked()">
										CHANGE IMAGE
									</button>
									<input type="file" #entityImage (change)="onImageFileChange($event)" style="display:none" accept=".gif,.jpg,.png"/>
									<img [src]="imageSource()" style="max-width: 40px; max-height: 40px" />
								</div>
							</div> 
						</div>

						<!-- Icon -->
						<div class="row" *ngIf="!isEntityType_Location() && !isEntityType_Zone()">
							<div class="form-group">
								<div class="col-sm-4"><label class="labelNormal">Icon</label></div>
								<div class="col-sm-8">
									<button class="btn btn-ef" type="button" style="width: 150px; margin-right: 20px; margin-bottom: 2px" (click)="changeIconClicked()">
										CHANGE ICON
									</button>
									<input type="file" #entityIcon (change)="onIconFileChange($event)" style="display:none" accept=".gif,.jpg,.png" />
									<img [src]="iconSource()" style="max-width: 40px; max-height: 40px" />
								</div>
							</div>
						</div>

						<!-- Groups -->
						<div class="row">
							<div class="form-group" *ngIf="isEditDialog() || entity.groups != null">
								<div class="col-sm-4"><label class="labelNormal">Groups</label></div>
								<div class="col-sm-8">
									<ng-container *ngIf="entity.groups != null">
										<ng-container *ngFor="let group of entity.groups">
											<button class="groupButton" (click)="showGroupClicked(group)">{{group.name}}</button>
										</ng-container>
									</ng-container>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- Properties Tab -->
				<div class="tab-pane fade in" id="additionalParams">
					<button type="button" class="btn btn-ef" (click)="addNewParameter()">Add New Parameter</button>
					<div id="newParamsDiv" *ngIf="entity.properties != null">
						<ng-container *ngFor="let property of entity.properties">
							<div class="objectParameterDiv input-group" style="display:block">
								<div class="row">
									<span class="col-sm-2"><a (click)="removeParameter(property)"><em class="fa fa-minus-square"></em></a> Key:</span>
									<span class="col-sm-4"><input type="text" class="form-control" [(ngModel)]="property.property"/></span>
									<span class="col-sm-2">Type:</span>
									<span class="col-sm-4">
										<select class="form-control" [(ngModel)]="property.type">
											<option *ngFor="let propertyType of getPropertyTypes()" [ngValue]="propertyType">
											{{mPropertyTypeService.getDisplayValueForPropertyType(propertyType)}}
											</option>
										</select>
									</span>
								</div>

								<div class="row">
									<span class="col-sm-2">Displayed Name:</span>
									<span class="col-sm-4"><input type="text" class="form-control" [(ngModel)]="property.name" /></span>
									<span class="col-sm-2">Display As:</span>
									<span class="col-sm-4">
										<select class="form-control" [(ngModel)]="property.parameter">
											<option *ngFor="let parameter of getParametersForPropertyType(property.type)" [ngValue]="parameter.value">
												{{parameter.displayValue}}
											</option>
										</select>
									</span>
								</div>

								<div class="row">
									<span class="col-sm-2">Help Text:</span>
									<span class="col-sm-10"><input type="text" class="form-control" [(ngModel)]="property.helpText"/></span>
								</div>

								<div class="row">
									<span class="col-sm-2">Multiple:</span>
									<span class="col-sm-4"><input type="checkbox" class="form-control" [(ngModel)]="property.multiple" /></span>
									<span class="col-sm-2">Required:</span>
									<span class="col-sm-4"><input type="checkbox" class="form-control" [(ngModel)]="property.required" /></span>
								</div>

								<div class="row">
									<span class="col-sm-2">Main Display:</span>
									<span class="col-sm-4"><input type="checkbox" class="form-control" [(ngModel)]="property.mainDisplay" /></span>
									<span class="col-sm-2">Hidden:</span>
									<span class="col-sm-4"><input type="checkbox" class="form-control" [(ngModel)]="property.hidden" /></span>
								</div>
							</div>
						</ng-container>
					</div>
				</div>
			</div>
		</div>

		<!-- Dialog Footer -->
		<div class="modal-footer">
			<button type="button" class="btn btn-default" (click)="hideDialog()"><i class="fa fa-ban"></i> CANCEL</button>
			<button *ngIf="isNewDialog()" class="btn btn-primary" (click)="createOrUpdateClicked()"><i class="fa fa-plus"></i> CREATE</button>
			<button *ngIf="isEditDialog()" class="btn btn-primary" (click)="createOrUpdateClicked()"><i class="fa fa-refresh"></i> UPDATE</button>
		</div>
	</div>
</div>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>
